const routes = [
    {
      path: '/product/modifier/:modifierId?/:nav?/:page?',
      props: true,
      component: () => import('@/views/base/modifier/Modifier.vue')
    },
    {
      path: '/products/modifiers/:page?',
      props: true,
      component: () => import('@/views/base/modifier/Modifiers.vue')
    }
  ]
  
  export default routes
  